import type { ReactNode } from 'react';
import { memo, useMemo } from 'react';
import { createContext, useContextSelector } from 'use-context-selector';
import type { AssetDndZone } from '../utils/types';

const DndZoneContext = createContext<{ zone: AssetDndZone }>({
  zone: null,
});

/**
 * wrap a zone of the app in this provider to automatically namespace any asset
 * dnd op
 * */
export const DndZoneContextProvider = memo(
  ({ children, zone = null }: { children: ReactNode; zone: AssetDndZone }) => {
    return (
      <DndZoneContext.Provider value={useMemo(() => ({ zone }), [zone])}>
        {children}
      </DndZoneContext.Provider>
    );
  }
);

export const useAssetDndZone = () => {
  return useContextSelector(DndZoneContext, ({ zone }) => zone);
};
